import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";

type ProgressFavorite = {
  id: string;
  title: string;
  progressNote: string;
};

function useProgressFavorites() {
  return useAxiosQuery(["progressFavorites"], () =>
    axiosChartInstance.get<ProgressFavorite[]>(`v1/chart-progress-favorite`)
  );
}

export type { ProgressFavorite };
export { useProgressFavorites };
